var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNursestation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "09_\u62A4\u58EB\u5DE5\u4F5C\u7AD9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54,52.35c-1.65-1.64-3.91-3.87-4.21-7.37-.65-7.49-2.1-12.21-4.28-15.17a1.74,1.74,0,0,0,.22-.48l5.06-15.95a3.42,3.42,0,0,0-.19-2.57A3.12,3.12,0,0,0,48.7,9.23a55.39,55.39,0,0,0-32.89,0A3.11,3.11,0,0,0,14,10.81a3.31,3.31,0,0,0-.2,2.56l5.06,16a.87.87,0,0,0,.07.17c-2.32,2.94-3.84,7.72-4.52,15.48-.31,3.5-2.61,5.75-4.29,7.39C8.81,53.59,7.5,54.87,8.19,56.6s1.51,2.13,10.53,2.13c2.48,0,5.59,0,9.48-.06l7.39-.07h.56c4,0,7.22.08,9.72.08,8.46,0,9.24-.39,9.93-2.11S55.21,53.59,54,52.35ZM17.92,13A51.42,51.42,0,0,1,46.6,13L42.19,26.84a17,17,0,0,0-7.57-1.9,2.06,2.06,0,0,0-.65-.11c-4.68,0-8.61.17-11.71,1.82ZM36.2,54.44h-.73l-7.3.07c-6.69,0-11.59.1-14.38,0a14.75,14.75,0,0,0,4.64-9.15C19.75,30.16,23.92,29.08,32.05,29s12.3,1.15,13.62,16.34a14.77,14.77,0,0,0,4.57,9.11C47.5,54.56,42.73,54.51,36.2,54.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19.84h3.91V22a2,2,0,0,0,3.94,0V19.84h3.92a2,2,0,0,0,2-2v-.13a2,2,0,0,0-2-2H34.8V13.57a2,2,0,0,0-3.94,0v2.15H27a2,2,0,0,0-2,2v.13A2,2,0,0,0,27,19.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNursestation);
export default __webpack_public_path__ + "static/media/nursestation.9484fac2.svg";
export { ForwardRef as ReactComponent };